module.exports = __webpack_public_path__ + "media/images/soar/pt-BR/googlePlay-a700736268a8fde65bb3ef07c2e1cca1.png";